module.exports = __webpack_public_path__ + "img/missile-swarm.f1cf15ce.svg";